export default __webpack_public_path__ + "static/media/file-for-git.31d6cfe0.bin";